export class ConnectionError extends Error {
  public readonly isConnectionError = true;
}

export function isConnectionError(e: unknown): e is ConnectionError {
  return e !== null && typeof e === 'object' && 'isConnectionError' in e;
}
